import { useEffect } from "react";
import { APP_NAME } from "../../util/brand";
import { BRAND } from "../../brand";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://videobrief.ai";

export default function SeoHead({ title, description, path = "" }) {
  const pageTitle = title ? `${title} | ${APP_NAME}` : (BRAND.seoTitle || `${APP_NAME} — AI video intelligence`);
  const desc = description || BRAND.seoDescription;

  const canonical = `${SITE_URL.replace(/\/$/, "")}${path.startsWith("/") ? path : `/${path}`}`;

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (name, content, prop = false) => {
      const attr = prop ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", desc);
    setMeta("og:title", pageTitle, true);
    setMeta("og:description", desc, true);
    setMeta("og:url", canonical, true);
    setMeta("og:type", "website", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", pageTitle);
    setMeta("twitter:description", desc);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = canonical;

    let script = document.getElementById("jsonld-org");
    if (!script) {
      script = document.createElement("script");
      script.id = "jsonld-org";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          name: APP_NAME,
          url: SITE_URL,
          sameAs: [
            "https://videobrief.ai",
            "https://ringdigital.tv",
            "https://futureoftv.live",
          ],
        },
        {
          "@type": "WebSite",
          name: APP_NAME,
          url: SITE_URL,
        },
        {
          "@type": "SoftwareApplication",
          name: APP_NAME,
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web",
          offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
          description: desc,
        },
      ],
    });
  }, [pageTitle, desc, canonical]);

  return null;
}
